export default __webpack_public_path__ + "static/media/KOD0089-min.8d041518.webp";